import { FC } from 'react'
import TextArea, { TextAreaProps } from 'antd/es/input/TextArea'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import cn from './index.module.css'
import classNames from 'classnames'

interface TextAreaFieldProps extends TextAreaProps {
  label?: string
  isInvalid?: boolean
}

const TextAreaField: FC<TextAreaFieldProps> = ({
  label,
  isInvalid,
  className,
  ...props
}) => {
  return (
    <FieldWrapper label={label} isInvalid={isInvalid}>
      <TextArea
        {...props}
        className={classNames(cn.input, isInvalid && cn.invalid, className)}
      />
    </FieldWrapper>
  )
}

export default TextAreaField
